
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  props: [
    "itemId",
    "productId",
    "productName",
    "extras",
    "amount",
    "price",
    "click",
    "counterItems",
    "status",
    "note",
  ],
  components: {},
})
export default class OrderItem extends Vue {}
